import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e8343c88&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e8343c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8343c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8343c88')) {
      api.createRecord('e8343c88', component.options)
    } else {
      api.reload('e8343c88', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e8343c88&scoped=true&", function () {
      api.rerender('e8343c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_recipient/detail.vue"
export default component.exports